// EG-63 — linguagem visual da área de auditoria (`/audit/view`), à parte do
// resto do painel de propósito: a tela é uma superfície de REVISÃO (o auditor lê
// as respostas de uma empresa e julga), não uma tela de cadastro. Fundo levemente
// quente, cartão de papel, um acento funcional só, hierarquia por peso/tamanho.
// Sem tocar no tema global do Chakra — igual dashboardTokens.js.
//
// Guarda-corpo (lições acumuladas): nada de emoji como ícone, nada de gradiente
// decorativo, nada de "glow" em sombra, nada de chrome escuro. Ícone é traço
// (react-icons/fi). Cor de status é semântica e discreta.

export const AUDIT = {
  // Superfícies
  ground: '#FAF9F6', // fundo da área (mais quente que o lilás #F5F5FB do painel)
  surface: '#FFFFFF', // cartão
  quote: '#FCFBF9', // bloco "resposta da empresa" (citação)
  panel: '#F3F6F8', // painel "avaliação do auditor" (frio, separa da citação)

  // Traços
  line: '#E8E4DD', // borda de cartão / divisórias (cinza quente, 1px)
  lineStrong: '#D8D3C9',

  // Tinta
  ink: '#1F2933', // texto principal (slate profundo)
  inkMuted: '#5B6470', // secundário
  inkFaint: '#8A929C', // rótulos, metadados

  // Acento de ação (azul "considerado", não CTA berrante)
  accent: '#1D6FA3',
  accentSoft: '#EAF2F7',
  accentInk: '#12507A',

  // Status (semântico, discreto) — usado no rail do cartão e nos selos
  statusPending: '#B9B2A4', // ainda não avaliada
  statusDone: '#3F8A5B', // nota atribuída / evidência aceita
  statusAttention: '#C9792E', // recusada / precisa de ajuste
  statusUnanswered: '#C0554A', // empresa não respondeu

  // Selos suaves (bg + texto)
  tagNeutralBg: '#F0EEE9',
  tagNeutralInk: '#5B6470',
  tagAccentBg: '#EAF2F7',
  tagAccentInk: '#12507A',
  tagGriBg: '#EEF4EF',
  tagGriInk: '#2F6B45',

  radius: '10px',
  radiusSm: '8px',
  shadow: '0 1px 2px rgba(31, 41, 51, 0.05), 0 1px 3px rgba(31, 41, 51, 0.04)',

  // Ritmo de espaçamento da área
  gapCard: '14px', // entre cartões
  padCard: '22px', // interno do cartão
};

// Rótulo de seção dentro do cartão (12px, caixa alta, tracking) — um só lugar
// pra não divergir entre "RESPOSTA DA EMPRESA" e "AVALIAÇÃO".
export const AUDIT_LABEL = {
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: AUDIT.inkFaint,
};

// Cor do rail (barra vertical à esquerda do cartão) a partir do estado da questão.
export function corDoRail({ respondida, temNota, evidenciaRecusada }) {
  if (!respondida) return AUDIT.statusUnanswered;
  if (evidenciaRecusada) return AUDIT.statusAttention;
  if (temNota) return AUDIT.statusDone;
  return AUDIT.statusPending;
}
